import { setBaseUrl, setGuestUserId, setupStore } from "@next-platform/client-common-core";
import { API_URL, LOAD_AS_APPLICATION_ID } from "@next-platform/client-common-core/infra/constants";
import basicAppConfig from "@next-platform/client-common-core/infra/constants/basicAppConfig";
import { ILocalStorage } from "@next-platform/client-common-core/storeTypes";
import { Middleware } from "@reduxjs/toolkit";
import { v4 as uuidv4 } from "uuid";

import { APPLICATIONS_NAME, GUEST_USER_ID_KEY, SHOULD_SHOW_FTUE_MODAL_LOCAL_STORAGE_KEY } from "@/constants";
import jsonApiService from "@/services/jsonApiService";
import { getCookie, loadAsApplication } from "@/utils";
import { AuthProvider } from "@/utils/authProvider";

import configureMockApi from "./debug/configureMockApi";
import { apiErrorMiddleware, userMiddleware } from "./middlewares";

const middleware = [userMiddleware, apiErrorMiddleware] as unknown as Middleware[];

// Conditionally add LogRocket middleware if window.LogRocket is defined
if (window.LogRocket && window.LogRocket.reduxMiddleware) {
  middleware.push(window.LogRocket.reduxMiddleware());
}

// Useful if we want to load localhost as a particular app, otherwise use spicychat
const MODE = import.meta.env.MODE || "";
const IS_DEBUG_REQUIRED = !MODE.includes("production") || (MODE.includes("production") && MODE.includes("offline"));
if (IS_DEBUG_REQUIRED) {
  const appToLoad = LOAD_AS_APPLICATION_ID ?? APPLICATIONS_NAME.SPICYCHAT;
  loadAsApplication(appToLoad, true);
}
const store = setupStore(
  new AuthProvider(),
  localStorage as unknown as ILocalStorage,
  {
    getCookie: (name: string) => getCookie(name),
  },
  middleware,
);

let storedGuestUserId = localStorage.getItem(GUEST_USER_ID_KEY);
if (!storedGuestUserId) {
  storedGuestUserId = uuidv4();
  localStorage.setItem(GUEST_USER_ID_KEY, storedGuestUserId);
  localStorage.setItem(SHOULD_SHOW_FTUE_MODAL_LOCAL_STORAGE_KEY, "true");
}
store.dispatch(setGuestUserId(storedGuestUserId));
const API_BASE_URL = API_URL || "";

setBaseUrl(API_BASE_URL);
jsonApiService.setBaseUrl(API_BASE_URL);
if (!IS_PRODUCTION_MODE) {
  configureMockApi({ service: jsonApiService });
}

jsonApiService.setApplicationId(basicAppConfig.applicationId);

export type RootState = ReturnType<typeof store.getState>;
export default store;
